var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accent"},[_c('v-container',{staticClass:"pa-3 pa-md-4",attrs:{"fluid":""}},[_c('app-action-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }